<template>
  <sidebar-layout :sidebarItems="sidebarItems">
    <template v-slot:mainContent>
      <router-view></router-view>
    </template>
  </sidebar-layout>
</template>

<script>
import SidebarLayout from "@/modules/commonModule/layouts/SidebarLayout";
export default {
  name: "AdminMainView",
  components: { SidebarLayout },
  data() {
    return {
      sidebarItems: [
        {
          text: "Dashboard",
          link: "/admin/dashboard",
          icon: "view-dashboard"
        },
        {
            text: "All Users",
            link: "/admin/all-users",
            icon: "account-multiple"
        },
        {
          text: "New User",
          link: "/admin/new-user",
          icon: "account-plus"
        },
        {
          text: "Profile Settings",
          link: "/admin/profile-settings",
          icon: "settings"
        },
      ]
    };
  }
};
</script>
